import { Component, EventEmitter, Input, OnDestroy, Output, QueryList, ViewChildren } from '@angular/core';
import { MatDrawer } from '@angular/material/sidenav';
import { SlideNavService } from '../slidenav.service';

@Component({
    selector: 'slidenavpanel',
    templateUrl: 'slidenavpanel.component.html'
})
export class SlideNavPanelComponent implements OnDestroy {
    @Input('slideDrawer') public slideDrawer: MatDrawer;
    @Output() deleteMultiple = new EventEmitter<number[]>();

    @ViewChildren('slidenavpanel') slides: QueryList<any>;
    markedForDeletion = {};
    readyToDelete = false;
    constructor(
        public slidenav: SlideNavService
    ) {
    }

    markForDelete(index: number) {
        if(this.markedForDeletion[index] === 'marked-for-delete') {
            delete this.markedForDeletion[index];
        } else {
            this.markedForDeletion[index] = 'marked-for-delete';
        }

        if(Object.keys(this.markedForDeletion).length > 0) {
            this.readyToDelete = true;
        } else {
            this.readyToDelete = false;
        }
    }

    clearSelection() {
        this.markedForDeletion = {};
        this.readyToDelete = false;
    }

    deleteSelected() {
        let slidesToDelete = Object.keys(this.markedForDeletion).map((key) => {
            return parseInt(key);
        });
        console.log(slidesToDelete);
        this.deleteMultiple.emit(slidesToDelete);
        this.markedForDeletion = {};
        this.readyToDelete = false;
    }

    drop(e) {
        this.slidenav.drop(this.slides, e);

        // If the slide was marked for deletion, remove it from the list
        if(this.markedForDeletion[e.data]) {
            delete this.markedForDeletion[e.data];
        }

        if(this.markedForDeletion[e.index]) {
            delete this.markedForDeletion[e.index];
        }
    }
    
    ngOnDestroy(): void {
        this.slidenav.ngOnDestroy();
    }
}